export function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('/');
}

export function formatDate2(date) {
    if (!date) return '';
    const d = new Date(date);
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(d);
}

export function formatDateUS(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [month, day, year].join('/');
}
export function formatDateMonth(dateStr) {
    const date = new Date(dateStr);

    const options = { year: 'numeric', month: 'long', day: 'numeric'};
    const formattedDate = date.toLocaleDateString('en-US', options);
    const formattedTime = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  
    return `${formattedDate} ${formattedTime}`;
  }

export function formatDateLine(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export function formatDateLineTime(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = d.getHours(),
        minutes = d.getMinutes(),
        seconds = d.getSeconds();


    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return `${[year, month, day].join('-')} ${[hour, minutes, seconds].join(':')}`;
}

export function checkDate(dateStr, comma) {
    let today = new Date();
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    
    let inputDate = new Date(dateStr);
    
    if (inputDate.toDateString() === yesterday.toDateString()) {
        return "Yesterday";
    } else {
        let month = inputDate.toLocaleString('default', { month: 'short' });
        let day = inputDate.getDate();
        let year = inputDate.getFullYear();
        if(comma){
            return  day + ' ' + month + ', ' + year
        }
        return  day + ' ' + month + ' ' + year
    }
}
export const formatTime = (time) => {
    const timePart = time.split(' ')[1].slice(0, 5);
    const [hourStr, minuteStr] = timePart.split(':');
    const hour = parseInt(hourStr, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedTime = `${hour > 12 ? hour - 12 : hour}:${minuteStr} ${period}`;
    return formattedTime
}
export function formatDateNoty(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
    if (diffDays === 0) {
      return "Today";
    } else if (diffDays === 1) {
      return "Yesterday";
    } else if (diffDays <= 6) {
      return `${diffDays} Days ago`;
    } else {
      const options = { month: 'long', day: 'numeric', year: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    }
  }

export const convertTo24HourFormat = (time12h) => {
    const [time, modifier] = time12h.split(/([APM]+)/i);
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier.toUpperCase() === 'PM' && hours < 12) {
        hours += 12;
    }

    if (modifier.toUpperCase() === 'AM' && hours === 12) {
        hours = 0;
    }

    return hours;
};

export function formatDateWithTime(dateString, noseconds = false) {
    const date = new Date(dateString);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12 || 12; 
    hours = String(hours).padStart(2, '0');
    
    return noseconds ? `${year}-${month}-${day} ${hours}:${minutes}${period}` : `${year}-${month}-${day} ${hours}:${minutes}:00`;
}

export function getTimezone(date) {
    const options = { timeZoneName: 'short' };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    
    const parts = formatter.formatToParts(date);
    const timeZonePart = parts.find(part => part.type === 'timeZoneName');
    
    return timeZonePart ? timeZonePart.value : 'Unknown Timezone';
}